import { getContrastColor } from '../../shared/colorUtils';
import type { StatusBadgeProps } from '../types/ui';

const StatusBadge = ({ color, label, className = '' }: StatusBadgeProps) => {
  const backgroundColor = color || 'var(--tblr-secondary)';
  const foregroundColor = color ? getContrastColor(color) : '#fff';

  return (
    <span className={`badge ${className}`} style={{ backgroundColor, color: foregroundColor }}>
      {label || '-'}
    </span>
  );
};

export default StatusBadge;
